import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import {
  SigninContainer,
  SigninWrapper,
  SigninP,
  SigninInput,
  SigninButton,
  SigninTitle,
  SigninSubtitle,
  Divider,
  PasswordRow,
  EyeButton,
  BottomText,
  ErrorText,
  BrandLogo,
} from "./SigninElements";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import logo from "../../images/logo (6).jpg";

const SignUpPage = () => {
  const [fullname, setFullname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [conformpassword, setConformPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignup = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== conformpassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/signup`, {
        fullname,
        email,
        password,
      });

      if (response.status === 200 || response.status === 201) {
        toast.success('Account created successfully!');
        navigate("/books");
      }
    } catch (error) {
      const message = error.response?.data?.message || "Unable to connect to the server.";
      setError(message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <SigninContainer>
      <SigninWrapper>
        <BrandLogo>
          <img src={logo} alt="CRME Logo" />
        </BrandLogo>
        <SigninTitle>Create Account</SigninTitle>
        <SigninSubtitle>Join Covenant Reformed Ministry Ethiopia</SigninSubtitle>
        <Divider />

        {error && <ErrorText>{error}</ErrorText>}

        <form onSubmit={handleSignup} style={{ width: "100%" }}>
          <SigninP>Full Name</SigninP>
          <SigninInput
            type="text"
            placeholder="Enter your full name"
            value={fullname}
            onChange={(e) => setFullname(e.target.value)}
            required
          />

          <SigninP>Email</SigninP>
          <SigninInput
            type="email"
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <SigninP>Password</SigninP>
          <PasswordRow>
            <SigninInput
              type={showPassword ? "text" : "password"}
              placeholder="Create a password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <EyeButton onClick={() => setShowPassword(!showPassword)}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </EyeButton>
          </PasswordRow>

          <SigninP>Confirm Password</SigninP>
          <PasswordRow>
            <SigninInput
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirm your password"
              value={conformpassword}
              onChange={(e) => setConformPassword(e.target.value)}
              required
            />
            <EyeButton onClick={() => setShowConfirmPassword(!showConfirmPassword)}>
              {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
            </EyeButton>
          </PasswordRow>

          <SigninButton type="submit" disabled={loading}>
            {loading ? 'Creating Account...' : 'Sign Up'}
          </SigninButton>
        </form>

        <BottomText>
          Already have an account? <Link to="/signin">Sign In</Link>
        </BottomText>
      </SigninWrapper>
    </SigninContainer>
  );
};

export default SignUpPage;
